import React from "react";

interface FocusedMusicIconProps {
  className?: string;
  style?: React.CSSProperties;
  focused?: boolean;
}

/**
 * Custom Music icon matching Lucide's design,
 * with selective white fill on the note circles when focused (light mode only).
 * In dark mode, no fill is applied.
 */
export function FocusedMusicIcon({ className, style, focused }: FocusedMusicIconProps) {
  const isDarkMode = typeof document !== 'undefined' && document.documentElement.classList.contains('dark');
  const shouldFill = focused && !isDarkMode;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={style}
    >
      <path d="M9 18V5l12-2v13" />
      <circle cx="6" cy="18" r="3" fill={shouldFill ? "white" : "none"} />
      <circle cx="18" cy="16" r="3" fill={shouldFill ? "white" : "none"} />
    </svg>
  );
}
